(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  $$('[data-stx-countdown]').forEach(function (el) {
    function tick() {
      var now = new Date(), end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
      var q = function (k, v) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = pad(v); };
      q('d', d); q('h', h); q('m', m); q('s', s);
    }
    tick(); setInterval(tick, 1000);
  });

  var drawer = $('[data-stx-drawer]');
  $$('[data-stx-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { if (drawer) drawer.hidden = false; }); });
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-stx-drawer-close]')) drawer.hidden = true; });
  }

  $$('.stx-loc').forEach(function (loc) {
    var btn = loc.querySelector('[data-stx-loc-toggle]'), list = loc.querySelector('.stx-loc__list'), form = loc.querySelector('form');
    btn.addEventListener('click', function (e) { e.stopPropagation(); list.hidden = !list.hidden; btn.setAttribute('aria-expanded', String(!list.hidden)); });
    $$('a[data-value]', list).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); form.querySelector('input[name="country_code"]').value = a.dataset.value; form.submit(); });
    });
    document.addEventListener('click', function (e) { if (!loc.contains(e.target)) list.hidden = true; });
  });

  $$('[data-stx-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-stx-gallery-main]'), thumbs = $$('.stx-gallery__thumb', g);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { main.scrollTo({ left: main.clientWidth * Number(t.dataset.index), behavior: 'smooth' }); });
    });
    var timer;
    main.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, 60);
    });
  });

  $$('[data-stx-product]').forEach(function (p) {
    var qty = p.querySelector('[data-stx-qty]');
    var tiers = $$('.stx-tier', p);
    function sync() {
      tiers.forEach(function (t) {
        var r = t.querySelector('input'); t.classList.toggle('is-selected', r.checked);
        if (r.checked && qty) qty.value = r.value;
      });
    }
    tiers.forEach(function (t) { t.querySelector('input').addEventListener('change', sync); });
    if (tiers.length && !tiers.some(function (t) { return t.querySelector('input').checked; })) tiers[0].querySelector('input').checked = true;
    sync();
  });

  $$('.stx-faq').forEach(function (faq) {
    $$('.stx-faq__item', faq).forEach(function (item) {
      var q = item.querySelector('.stx-faq__q'), a = item.querySelector('.stx-faq__a');
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        $$('.stx-faq__item', faq).forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.stx-faq__a').style.maxHeight = null; o.querySelector('.stx-faq__q').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  var sticky = $('[data-stx-sticky]');
  if (sticky) {
    var atc = $('[data-stx-atc]');
    var onScroll = function () {
      var show = atc ? atc.getBoundingClientRect().bottom < -100 : window.scrollY > 600;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var sb = sticky.querySelector('[data-stx-sticky-atc]');
    sb.addEventListener('click', function () {
      var form = $('.stx-buy__form');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); return; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(sb.dataset.variant), quantity: 1 }] }) })
        .then(function () { window.location.href = '/cart'; });
    });
  }

  $$('.stx-section-testi').forEach(function (sec) {
    var track = sec.querySelector('[data-stx-slider]'); if (!track) return;
    var cards = $$('.stx-testi__card', track), dots = $$('[data-stx-dots] span', sec);
    function step() { return cards[0] ? cards[0].getBoundingClientRect().width + 20 : 300; }
    sec.querySelector('[data-stx-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    sec.querySelector('[data-stx-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === Math.min(i, dots.length - 1)); });
    }, { passive: true });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var bar = en.target.querySelector('.stx-stat__bar');
        if (bar) bar.style.strokeDasharray = bar.dataset.dash + ' 264';
        io.unobserve(en.target);
      });
    }, { threshold: .3 });
    $$('[data-stx-ring]').forEach(function (r) { io.observe(r); });
  } else {
    $$('.stx-stat__bar').forEach(function (b) { b.style.strokeDasharray = b.dataset.dash + ' 264'; });
  }
  $$('[data-stx-roadmap]').forEach(function (rm) {
    var fill = rm.querySelector('[data-stx-roadmap-fill]');
    function upd() {
      var r = rm.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * .6 - r.top) / r.height));
      fill.style.height = (p * 100) + '%';
    }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  });

  $$('[data-stx-reviews-more]').forEach(function (btn) {
    var list = btn.closest('.stx-reviews').querySelector('[data-stx-reviews]');
    var per = Number(list.dataset.perPage) || 5;
    btn.addEventListener('click', function () {
      $$('.stx-review.is-hidden', list).slice(0, per).forEach(function (r) { r.classList.remove('is-hidden'); });
      if (!list.querySelector('.stx-review.is-hidden')) btn.remove();
    });
  });
})();
